import { Section } from '@sparknz/spark-pattern-library/types/components/Layers/ActionLayer/components/ProgressIndicator';

import { ChangePlanButtonMutation$data } from '__generated__/ChangePlanButtonMutation.graphql';

export enum ViewState {
  ManageAccount = 'MANAGE_ACCOUNT',
  ManageLines = 'MANAGE_LINE',
  SelectParentPlan = 'SELECT_PARENT_PLAN',
}

interface ChangePlanRedirect {
  path: string;
  planId: string;
}

type SelectedLine = NonNullable<
  ChangePlanButtonMutation$data['updateMobileChangePlanUser']['eligibleLines']
>[0];

export interface UserInfoUpdateType {
  accounts?: ChangePlanButtonMutation$data['updateMobileChangePlanUser']['accounts'];
  eligibleLines?: ChangePlanButtonMutation$data['updateMobileChangePlanUser']['eligibleLines'];
  selectedAccount?: string;
  selectedLine?: SelectedLine | null;
  redirect?: ChangePlanRedirect | null;
  isEligibilityCheckRequired?: boolean;
}

export type BreadcrumbClickEvent = { section: Section };
